export default "__VITE_ASSET__Cq3A1T9P__"